import { render, staticRenderFns } from "./ReferenceIndexList.vue?vue&type=template&id=1abebbfc"
import script from "./ReferenceIndexList.vue?vue&type=script&lang=js"
export * from "./ReferenceIndexList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports